import _ from 'lodash';
import {AlarmStage} from '../alarmStage';
import moment from 'moment/moment';
import React from 'react';
import {useSelector} from 'react-redux';
import {additionalData} from '../../../../store/reducers/additionalData';
import {useTranslation} from 'react-i18next';

const MainScreenAlerts = () => {
    const {t} = useTranslation();

    // Selectors
    const patientAddData = useSelector(additionalData);

    const getAlerts = () => {
        let alerts_banners = [];

        const handleAlarmStatus = (status) => {
            switch (status) {
                case 'confirm':
                    return 'Positive';
                case 'none':
                    return 'Negative';
                case 'suspected':
                    return 'Suspected';
                default:
                    return 'N/D';
            }
        };

        if (patientAddData && patientAddData.other && patientAddData.other.alarms) {
            let tmp = [];

            _.forEach(_.orderBy(patientAddData.other.alarms, (alarm) => AlarmStage.AlarmStageP(alarm.stage)), (alarmGroupEl) => {
                tmp.push(alarmGroupEl);
            });

            tmp.forEach((alarmEl) => {
                if (!alarmEl.deleted && moment(alarmEl.expireDate).isAfter(moment()) && alarmEl.onBanner) {
                    alerts_banners.push(
                        <div key={alarmEl.id}
                             style={{
                                 background: alarmEl.stage,
                                 border: alarmEl.state === 'confirm' ?
                                     '3px solid ' + AlarmStage.AlarmStageBorder(alarmEl.stage)
                                     : 'none',
                                 color: AlarmStage.AlarmStageTextColor(alarmEl.stage),
                                 padding: '2px 6px', borderRadius: 5, marginTop: '3px',
                             }}
                        >
                            <div>
                                {`${alarmEl.name} ${t('is')} ${handleAlarmStatus(alarmEl.state)} ${t('for this patient')} | `}
                                {alarmEl.description &&
                                    <>

                                        <span style={{fontStyle: 'italic'}}>
                                            {alarmEl.description}
                                        </span>
                                        {' | '}
                                    </>
                                }
                                {`${t('expires')} ${moment(alarmEl.expireDate).format('DD/MM/YYYY')}`}
                            </div>
                        </div>,
                    );
                }
            });
        }

        if (alerts_banners.length > 0) {
            alerts_banners.push((<div key="seperator" style={{paddingBottom: 20}}/>));
        }
        return alerts_banners;
    };

    return getAlerts();
};

export default MainScreenAlerts;
